export const relations = [
  {
    name: 'formType',
    attrbName: 'formTypeId',
    relatedKey: 'id',
    relatedParentKey: 'formTypeId',
  },
];
